import { createReducer } from '@reduxjs/toolkit';
import { initializeClientEntries, updatePreviewEntry, touchAllFields, resetClient, addNewLoopEntry, deleteLoopEntry } from "../../actions/client";
import { getTimeFormat } from "../../../lib/fields/TimeField";
import { formatDate } from "../../../lib/fields/DateField";
import { getCurrentTime } from "../../../lib/utils";
export const formatDefault = ({
  type,
  value,
  default: defaultValue,
  style
}) => {
  const mappedValue = value || defaultValue;
  if (type === 'Multiple Choice') {
    return mappedValue ? [mappedValue] : [];
  }
  if (type === 'Time') {
    const format = getTimeFormat(style);
    return mappedValue || getCurrentTime(format);
  }
  if (type === 'Date') {
    return formatDate(mappedValue, style);
  }
  return mappedValue;
};
export const applyDefaults = entry => {
  const value = formatDefault(entry);
  return {
    ...entry,
    value,
    touched: false
  };
};
export const initializeClientEntriesMethod = (state, action) => {
  const {
    entries
  } = action.payload;
  return entries.map(entry => applyDefaults(entry));
};
export const clientEntriesReducer = createReducer([], {
  [initializeClientEntries]: initializeClientEntriesMethod,
  [updatePreviewEntry]: (state, action) => {
    const {
      guid
    } = action.payload;
    return state.map(entry => {
      if (entry.guid !== guid) return entry;
      return {
        ...entry,
        ...action.payload
      };
    });
  },
  [touchAllFields]: (state, action) => {
    const {
      sheet_ids
    } = action.payload;
    return state.map(entry => {
      if (sheet_ids.includes(entry.sheet_id)) {
        return {
          ...entry,
          touched: true
        };
      }
      return entry;
    });
  },
  [resetClient]: initializeClientEntriesMethod,
  [addNewLoopEntry]: (state, action) => {
    const {
      entries = []
    } = action.payload;
    const entriesWithDefaults = entries.map(applyDefaults);
    return [...state, ...entriesWithDefaults];
  },
  [deleteLoopEntry]: (state, action) => {
    const {
      activeRowGuid
    } = action.payload;
    return state.filter(({
      rowGuid
    }) => rowGuid !== activeRowGuid);
  }
});
export default clientEntriesReducer;